/**
 * When typescript can't infer a tuple you can use this
 * ```
 * const tupe = tuple('a', 'b');
 * => typeof tupe === ['a', 'b'];
 * ```
 *
 * @param args - The tuple parts
 * @returns The args as an array typed as a tuple
 */
export function tuple<T extends any[]>(...args: T): T {
    return args;
}
